<template lang="pug">
.container.grid-xl
  .card.mt-2
    .card-header
      .text-bold Filtrar
    .card-body
      form-filter(@submit="fetchReport")
  .full-height.loading.loading-lg(v-if="loading")
  div(v-else-if="report")
    div(v-if="report.length")
      .columns.no-print
        .column.col-6.col-lg-12.my-2
          .card
            .card-header
              .h5 Gráfico por quantidade
            .card-body.chart-body
              bar-chart(:data="chartData", :height="`${report.length * 50}px`")
        .column.col-6.col-lg-12.my-2
          .card
            .card-header
              .h5 Gráfico por valor
            .card-body.chart-body
              bar-chart(
                :data="chartDataValue",
                :height="`${report.length * 50}px`"
              )
      .card.my-2
        .card-header
          .h5 Tabela resumo
        .card-body
          table.table.table-striped.table-responsive
            thead
              tr
                th Grupo
                th.text-right Quantidade
                th.text-right Valor total
            tbody
              tr(v-for="item in report")
                td {{ item.grupo_nome }}
                td.text-right {{ item.q }}
                td.text-right {{ item.valor_total | currency("R$ ") }}
            tfoot.text-bold
              tr
                td
                td.text-right Total: {{ total }}
                td.text-right Total: {{ valorTotal | currency("R$ ") }}
    .card.mt-2(v-else)
      .card-body
        .empty
          .empty-icon
            i.fa.fa-search.fa-4x
          p.empty-title.h5 Nada encontrado
          p.empty-subtitle Não foram encontradas Notificações neste período
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors"
import docs from "@/api/indicadores/docs"
import FormFilter from "./components/Filter"

export default {
  data() {
    return {
      loading: false,
      report: null,
    }
  },
  components: { FormFilter },
  computed: {
    total() {
      return this.report.reduce((acc, item) => acc + Number(item.q), 0)
    },
    valorTotal() {
      return this.report.reduce(
        (acc, item) => acc + Number(item.valor_total),
        0,
      )
    },
    chartData() {
      return this.report.map((item) => [item.grupo_nome, Number(item.q)])
    },
    chartDataValue() {
      return this.report.map((item) => [
        item.grupo_nome,
        Number(item.valor_total),
      ])
    },
  },
  methods: {
    async fetchReport(q = {}) {
      try {
        this.loading = true
        this.report = await docs.porGrupo({ q })
      } catch (error) {
        toastErrors(error)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.fetchReport()
  },
}
</script>

<style lang="stylus" scoped>
.chart-body {
  max-height: 500px;
  overflow-y: auto;
}
</style>
